/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../dashboard/serializer/SerializerAPI',
	'../../../dashboard/model/ModelUtils'
], (APIFactory, SerializerAPI, ModelUtils) => {

	/**
	 * @implements {SerializerAPI}
	 */
	class Serializer {
		/**
		 * @param {Object} options
		 * @param {Object} options.features An object of the defined dependencies from the feature contribution json
		 */
		constructor({ layoutModel, content, logger }) {
			this._layoutModel = layoutModel;
			this._content = content;
			this._logger = logger;
			this._api = APIFactory.createAPI(this, [SerializerAPI]);
		}

		getAPI() {
			return this._api;
		}

		destroy() {
			delete this._layoutModel;
			delete this._content;
			delete this._api;
		}

		toJSON() {
			const json = this._layoutModel.toJSON(null, ['items']);
			const children = this._layoutModel.items;
			if(children) {
				json.items = [];
				children.forEach((child) => {
					const childContent = this._content.getContent(child.id);
					if(childContent) {
						json.items.push(childContent.getFeature('Serializer').toJSON());
					} else {
						this._logger.log('Cannot get the child content');
					}
				});
			}
			ModelUtils.pullPropertiesFromContentModelSpec(json);
			return json;
		}
	}
	return Serializer;
});
